import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Заколодна Ольга',
  role: 'Голова комісії спортивного скелелазіння',
  email: 'olya-zak@ukr.net'
}, {
  name: 'Паукаєв Артем',
  role: 'Член комісії спортивного скелелазіння',
  email: 'paukclimb@gmail.com'
}, {
  name: 'Мардашов Антон',
  role: 'Член комісії спортивного скелелазіння',
  email: 'mardashov.anton@gmail.com'
}];
export function SportClimbingCommission() {
  return <FederationMembersPage title="Комісія спортивного скелелазіння" subtitle="Комісія спортивного скелелазіння ФАіСУ" members={members} data-id="element-564" />;
}